var _defs, _g, _path, _g2, _g3, _g4, _g5, _g6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBenefitsUpdated(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 507.4,
    height: 547.37,
    viewBox: "0 0 507.4 547.37",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 243.58,
    cy: 46.31,
    r: 29.6,
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 1539.63,
    y1: 1620.46,
    x2: 1540.63,
    y2: 1620.46,
    gradientTransform: "matrix(41.08, 0, 0, -41.08, -63378.73, 66656.35)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#2bc5b4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2bc5b4",
    stopOpacity: 0.47
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 967.94,
    y1: 5427.2,
    x2: 968.94,
    y2: 5427.2,
    gradientTransform: "matrix(56.9, 0, 0, -56.9, -55298.13, 309232.67)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#524cb3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5953b6",
    stopOpacity: 0.47
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 1065.1,
    y1: 5648.64,
    x2: 1066.1,
    y2: 5648.64,
    gradientTransform: "matrix(11.2, 69, 69, -11.2, -401453.26, -10035.61)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f79256"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f79256",
    stopOpacity: 0.48
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 1112.52,
    y1: 5606.19,
    x2: 1113.52,
    y2: 5606.19,
    gradientTransform: "matrix(56.9, 0, 0, -56.9, -63105.71, 319404.54)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 1112.52,
    y1: 5606.19,
    x2: 1113.52,
    y2: 5606.19,
    gradientTransform: "matrix(56.9, 0, 0, -56.9, -63116.71, 319099.55)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M234.25,233.29A163.9,163.9,0,0,0,199.08,252v47.17a120.41,120.41,0,0,1,35.17-22.61Z",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-4"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 199.08,
    y: 233.29,
    width: 35.17,
    height: 65.87,
    fill: "none"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "Rectangle_1_1_",
    "data-name": "Rectangle 1 1 ",
    width: 10,
    height: 10,
    patternTransform: "translate(543.95 1366.52)",
    patternUnits: "userSpaceOnUse",
    viewBox: "0 0 10 10"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 10,
    height: 10,
    fill: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 10,
    height: 10,
    fill: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 10,
    height: 10,
    fill: "none"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "all_layers",
    "data-name": "all layers"
  }, /*#__PURE__*/React.createElement("g", {
    id: "main_grp",
    "data-name": "main grp"
  }, /*#__PURE__*/React.createElement("path", {
    className: "dash-line",
    id: "heart_line",
    "data-name": "heart line",
    d: "M270.32,141.83v-52",
    fill: "none",
    stroke: "#f79256",
    strokeLinecap: "round",
    strokeWidth: 4,
    strokeDasharray: "5 10",
    opacity: 0.5,
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "dash-line",
    id: "swipe_line",
    "data-name": "swipe line",
    d: "M270.32,423.83v-119",
    fill: "none",
    stroke: "#f79256",
    strokeLinecap: "round",
    strokeWidth: 4,
    strokeDasharray: "5 10",
    opacity: 0.5,
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "dash-line",
    id: "people_line",
    "data-name": "people line",
    d: "M185,196.52l-54.69-54.69",
    fill: "none",
    stroke: "#f79256",
    strokeLinecap: "round",
    strokeWidth: 4,
    strokeDasharray: "5 10",
    opacity: 0.5,
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "dash-line",
    id: "dollar_line",
    "data-name": "dollar line",
    d: "M348.62,196.52l54.69-54.69",
    fill: "none",
    stroke: "#f79256",
    strokeLinecap: "round",
    strokeWidth: 4,
    strokeDasharray: "5 10",
    opacity: 0.5,
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "dash-line",
    id: "graph_line",
    "data-name": "graph line",
    d: "M185,327.13l-69.69,69.7",
    fill: "none",
    stroke: "#f79256",
    strokeLinecap: "round",
    strokeWidth: 4,
    strokeDasharray: "5 10",
    opacity: 0.5,
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "dash-line",
    id: "device_line",
    "data-name": "device line",
    d: "M323.31,301.83l95,95",
    fill: "none",
    stroke: "#f79256",
    strokeLinecap: "round",
    strokeWidth: 4,
    strokeDasharray: "5 10",
    opacity: 0.5,
    style: {
      isolation: "isolate"
    }
  }), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "heart_grp",
    "data-name": "heart grp"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_375",
    "data-name": "Ellipse 375",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 213.88,
    y: 16.71,
    width: 11,
    height: 59.3,
    fill: "#f79256"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 224.88,
    y: 16.71,
    width: 48.3,
    height: 59.3,
    fill: "#f79256"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Path_3183",
    "data-name": "Path 3183"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M316.47,34.61a8.08,8.08,0,0,0-14.1-5l-11,12.7a10.51,10.51,0,0,0-1.1,1.7l-.5.2a7.53,7.53,0,0,0-5.5-5.4c-14.59-4.1-16.49-5-20.39-4.6h0c-10.7,1.2-13.2,1.5-18.6,4.6a86.92,86.92,0,0,0-11.3,7.8l-.7-.8a4.57,4.57,0,0,0-6.4-.5l-15.5,13.4a4.52,4.52,0,0,0-.5,6.2h0l20.5,23.3a4.24,4.24,0,0,0,5.9.5h0l15.5-13.4a4.58,4.58,0,0,0,.5-6.4h0l-.6-.7,1-.9c2.6-2.3,6.6-3,10.7-1.8l10.29,2.9a2.18,2.18,0,1,0,1.2-4.2h0l-10.29-2.9a15.93,15.93,0,0,0-14.8,2.7l-1,.9-13-15a76.39,76.39,0,0,1,10.6-7.3c4.6-2.7,6.2-2.9,16.8-4,2.5-.2,4.1.2,12.59,2.7,6.6,1.9,8,1.9,8.6,3.9a3.55,3.55,0,0,1,.1,1.8,5.74,5.74,0,0,1-.5,1.2,2,2,0,0,1-2,.7c-4.2-.6-14.19-1.9-14.29-1.9a2.22,2.22,0,1,0-.6,4.4h0c.1,0,10.09,1.3,14.29,1.9a6.49,6.49,0,0,0,7.2-4.2c.1,0,22.4-9.2,22.5-9.3,2.3-1.2,4.6-1.5,6,.8,1.6,2.9-1.2,5-2,5.5l-29.6,17h-.1a7.26,7.26,0,0,1-1.6.8,2.19,2.19,0,0,0,1.8,4,19.93,19.93,0,0,0,2.1-1.1c.1,0,29.7-17,29.7-17,8.1-5.1,4.2-14.2-1.9-15.2ZM250,72h0c0,.1-15.3,13.3-15.3,13.4l-20.4-23.2,15.47-13.38h.2Zm48.89-31.5,6.8-7.9a3.54,3.54,0,0,1,5-.39l.11.09a3.32,3.32,0,0,1,1.2,2.8Z",
    fill: "#f79256"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Path_3184",
    "data-name": "Path 3184"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M280.47,7.31a3.77,3.77,0,0,0,3.1,1.7,3.65,3.65,0,0,0,2.9-1.7A5.81,5.81,0,0,1,294.36,5l.21.12a5.94,5.94,0,0,1,2.5,2.9,2.22,2.22,0,0,0,4.1-1.7A10.35,10.35,0,0,0,287.59.83h0a10.69,10.69,0,0,0-4.1,3.2c-6.1-7.8-18.59-3.4-18.59,6.4,0,10.3,8.9,18.2,17.29,22.1a3,3,0,0,0,2.6,0c6-2.8,12.4-7.9,15.3-14a2.3,2.3,0,0,0-1-3,2.2,2.2,0,0,0-3,1l0,0c-2.4,5-7.7,9.1-12.6,11.6-6.9-3.4-14.09-9.8-14.09-17.8a5.93,5.93,0,0,1,5.95-5.9h0a5.46,5.46,0,0,1,5.1,2.9Z",
    fill: "#f79256"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "people_grp",
    "data-name": "people grp",
    className: "people"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_385",
    "data-name": "Ellipse 385",
    cx: 46.88,
    cy: 88.98,
    r: 20.5,
    opacity: 0.3,
    fill: "url(#linear-gradient)",
    style: {
      isolation: "isolate"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_3207",
    "data-name": "Path 3207",
    d: "M110.38,65.88a28.18,28.18,0,0,0,.3-4.1,29.55,29.55,0,0,0-59.1-.5h0v.55a28.18,28.18,0,0,0,.3,4.1,26.24,26.24,0,0,0-1.9,50.4v6.3a1.58,1.58,0,0,0,1.56,1.6h0v4.9a1.58,1.58,0,0,0,1.56,1.6H63a1.58,1.58,0,0,0,1.6-1.56v-4.94a1.58,1.58,0,0,0,1.6-1.56v0h0v-6.3a25.1,25.1,0,0,0,8.2-4.5v17.3a1.58,1.58,0,0,0,1.56,1.6h9.84a1.58,1.58,0,0,0,1.6-1.56V111.83a25.1,25.1,0,0,0,8.2,4.5v6.3a1.58,1.58,0,0,0,1.56,1.6h0v4.9a1.58,1.58,0,0,0,1.56,1.6h9.84a1.58,1.58,0,0,0,1.6-1.56v-4.94a1.58,1.58,0,0,0,1.6-1.56v-6.34a26.13,26.13,0,0,0,16.75-32.94s0-.1-.05-.16a24.65,24.65,0,0,0-18.1-17.3Zm-29.3-30.3A26.31,26.31,0,0,1,99.18,81v-4.3a4.92,4.92,0,0,0-4.9-4.9h-8.2v-3a10,10,0,0,0,4.9-8.5v-1.6h.8a4.06,4.06,0,0,0,4.1-4v-.08a4.19,4.19,0,0,0-3.3-4.1v-5a4.92,4.92,0,0,0-4.9-4.9H76.48L71.78,39a1.61,1.61,0,0,0-1.5.2,1.71,1.71,0,0,0-.7,1.3v9.9a4.08,4.08,0,0,0,.8,8.1h.8v1.6a9.83,9.83,0,0,0,4.9,8.5v3h-8.2a4.91,4.91,0,0,0-4.9,4.9v4.3a26.35,26.35,0,0,1-1-37.2,26.8,26.8,0,0,1,19.1-8ZM68,91.38a5,5,0,0,1,3.3,1.3v6.9a1.58,1.58,0,0,0,1.56,1.6h0v1.65H43.28v-6.6a4.91,4.91,0,0,1,4.9-4.9Zm-16.5-9.9a6.57,6.57,0,0,1,3.5-5.8,29.59,29.59,0,0,0,8.3,9.7,6.55,6.55,0,0,1-9.18,1.31h0A6.32,6.32,0,0,1,51.51,81.48Zm13.9,6.6a6,6,0,0,0,.6-.8c.5.3,1,.5,1.5.8Zm.9-4.5v-7A1.58,1.58,0,0,1,67.87,75h6.84a6.47,6.47,0,0,0,7.84,4.72l.06,0a6.58,6.58,0,0,0,4.7-4.7h6.8a1.58,1.58,0,0,1,1.6,1.56v7a26.54,26.54,0,0,1-7,3.4,27.26,27.26,0,0,1-15.5,0A29.53,29.53,0,0,1,66.31,83.58ZM74.51,52h13.1v8.2a6.6,6.6,0,1,1-13.2,0h0V52Zm-1.6-3.3V42.83l2.8.9a.87.87,0,0,0,.5.1h11.5a1.58,1.58,0,0,1,1.6,1.56v3.34Zm11,26.3a3.28,3.28,0,0,1-4.46,1.23l0,0a3.29,3.29,0,0,1-1.2-1.2Zm-4.4-3.3v-1.8a9.15,9.15,0,0,0,3.3,0v1.8Zm16.6,15.6a4.64,4.64,0,0,0,.6.8h-2.1C95.21,87.78,95.61,87.58,96.11,87.28Zm-6.8,13.9a1.58,1.58,0,0,0,1.6-1.56V92.68a5,5,0,0,1,3.3-1.3h19.7a4.92,4.92,0,0,1,4.9,4.9v6.6H89.18Zm14.8-13.1a6.47,6.47,0,0,1-5.2-2.6,28.63,28.63,0,0,0,8.3-9.7,6.59,6.59,0,0,1,2.7,8.9A6.68,6.68,0,0,1,104.11,88.08ZM91,55.28v-1.6h.8a.8.8,0,0,1,0,1.6Zm-19.7-1.7v1.6h-.8a.8.8,0,0,1,0-1.6Zm-9.9,73.9h-6.6v-3.3h6.6Zm1.6-6.6h-9.8v-3.8a26.79,26.79,0,0,0,4.9.5,26.11,26.11,0,0,0,4.9-.5Zm11.5-13.5a23,23,0,1,1-22.1-38.3,26.62,26.62,0,0,0,1.2,3.7A9.83,9.83,0,0,0,49.31,86a7.82,7.82,0,0,0,1.5,2.1h-2.5a8.24,8.24,0,0,0-8.2,8.2v8.2a1.58,1.58,0,0,0,1.56,1.6H74.51Zm9.9,20.1h-6.6v-26.3h6.6ZM74.51,98v-7.3a29.32,29.32,0,0,0,6.6.7h1.6v-.1a41.86,41.86,0,0,0,5-.6V98Zm32.9,29.5h-6.6v-3.3h6.6Zm1.6-6.6h-9.8v-3.8a26.79,26.79,0,0,0,4.9.5,26.11,26.11,0,0,0,4.9-.5Zm-4.9-6.5a22.62,22.62,0,0,1-16.4-7v-1.2h32.8a1.58,1.58,0,0,0,1.6-1.56V96.38a8.24,8.24,0,0,0-8.2-8.2h-2.5a9.8,9.8,0,0,0-.7-13.8,10,10,0,0,0-2.1-1.5,23.85,23.85,0,0,0,1.2-3.7,23,23,0,0,1-5.7,45.2Z",
    fill: "#24afa0"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "graph_grp",
    "data-name": "graph grp",
    className: "graph"
  }, _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_7241",
    "data-name": "Group 7241"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3208",
    "data-name": "Path 3208",
    d: "M105.3,421.73v-31.8a11.37,11.37,0,1,0-13-11.3H14.4v64.9H63.2A25.95,25.95,0,0,0,115,440.69c0-.12,0-.24,0-.36A26.32,26.32,0,0,0,105.3,421.73Zm-1.6-51.2a8.07,8.07,0,1,1-.06,0Zm-86.1,11.4H92.7a10.4,10.4,0,0,0,1.8,3.5l-9.9,9.9a4.46,4.46,0,0,0-4.2,0L77.1,392a5.3,5.3,0,0,0,.5-2.1,4.9,4.9,0,1,0-9.8,0h0a5.3,5.3,0,0,0,.5,2.1l-8.1,8.1a5.26,5.26,0,0,0-2.1-.5,4.9,4.9,0,1,0,4.9,4.9h0a5.22,5.22,0,0,0-.5-2.1l8.1-8.1a4.46,4.46,0,0,0,4.2,0l3.3,3.3a4.88,4.88,0,0,0,8.8,4.2,4.66,4.66,0,0,0,0-4.3l9.9-9.9a11,11,0,0,0,5.2,2.1v29.6a26,26,0,0,0-32.5,5.3v-7.2H59.8v19.5h3.7c-.2,1.1-.3,2.2-.4,3.2H17.6Zm65,16.2a1.6,1.6,0,1,1-1.6,1.6,1.58,1.58,0,0,1,1.56-1.6ZM71.2,390a1.6,1.6,0,1,1,1.6,1.6,1.6,1.6,0,0,1-1.6-1.6Zm-11.4,14.6a1.6,1.6,0,1,1-1.6-1.6,1.57,1.57,0,0,1,1.6,1.56ZM89,454.92a13,13,0,1,1,13-13h0A13,13,0,0,1,89,454.92Zm-22.7-25.49a24.15,24.15,0,0,0-1.9,4.4h-1.3v-13h3.2Zm21.1-10.1v6.5a16.16,16.16,0,0,0-14.5,17.68v0a14.9,14.9,0,0,0,1.4,5.1l-5.6,3.19A22.61,22.61,0,0,1,79,421.56l.08,0a23,23,0,0,1,8.3-2.2Zm1.7,45.39a22.56,22.56,0,0,1-18.8-10l5.7-3.3a16.19,16.19,0,0,0,26.3,0l5.7,3.3A23.28,23.28,0,0,1,89.11,464.72Zm20.4-12.8-5.6-3.2a16.13,16.13,0,0,0-8-21.35l-.09,0a17.11,17.11,0,0,0-5.1-1.4v-6.6a22.8,22.8,0,0,1,18.8,32.59Z",
    fill: "#5d56c4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3209",
    "data-name": "Path 3209",
    d: "M89.1,432.23a9.7,9.7,0,1,0,9.7,9.7A9.7,9.7,0,0,0,89.1,432.23Zm0,16.2a6.5,6.5,0,1,1,6.5-6.5h0A6.63,6.63,0,0,1,89.1,448.43Z",
    fill: "#5d56c4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3210",
    "data-name": "Path 3210",
    d: "M20.9,385.23h3.2v3.2H20.9Z",
    fill: "#5d56c4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3211",
    "data-name": "Path 3211",
    d: "M27.4,385.23H50.1v3.2H27.4Z",
    fill: "#5d56c4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3212",
    "data-name": "Path 3212",
    d: "M20.9,391.63h3.2v3.2H20.9Z",
    fill: "#5d56c4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3213",
    "data-name": "Path 3213",
    d: "M27.4,391.63H50.1v3.2H27.4Z",
    fill: "#5d56c4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3214",
    "data-name": "Path 3214",
    d: "M20.9,398.13h3.2v3.2H20.9Z",
    fill: "#5d56c4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3215",
    "data-name": "Path 3215",
    d: "M27.4,398.13H50.1v3.2H27.4Z",
    fill: "#5d56c4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3216",
    "data-name": "Path 3216",
    d: "M20.9,404.63h3.2v3.2H20.9Z",
    fill: "#5d56c4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3217",
    "data-name": "Path 3217",
    d: "M27.4,404.63H50.1v3.2H27.4Z",
    fill: "#5d56c4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3218",
    "data-name": "Path 3218",
    d: "M20.9,437.13h9.7v-16.2H20.9Zm3.2-13h3.3v9.7H24.1Z",
    fill: "#5d56c4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3219",
    "data-name": "Path 3219",
    d: "M33.9,437.13h9.7v-13H33.9Zm3.2-9.8h3.3v6.5H37.2Z",
    fill: "#5d56c4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3220",
    "data-name": "Path 3220",
    d: "M46.9,437.13h9.7v-26H46.9Zm3.2-22.7h3.2v19.5H50.1Z",
    fill: "#5d56c4"
  }))), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_387",
    "data-name": "Ellipse 387",
    cx: 28.5,
    cy: 430.88,
    r: 28.5,
    opacity: 0.3,
    fill: "url(#linear-gradient-2)",
    style: {
      isolation: "isolate"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "swipe_grp",
    "data-name": "swipe grp",
    className: "swipe"
  }, _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Ecommerce-transfer_money-buy-smartphone-hands",
    "data-name": "Ecommerce-transfer money-buy-smartphone-hands"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3221",
    "data-name": "Path 3221",
    d: "M310.15,468.58l2.2,2.2,6.1-6.1a1.57,1.57,0,0,0,0-2.2h0l-6.1-6.1-2.2,2.2,3.5,3.5H296v3h17.6Z",
    fill: "#f79256"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3222",
    "data-name": "Path 3222",
    d: "M301,483l2.2-2.2-3.5-3.5h17.6v-3H299.7l3.5-3.5-2.2-2.2-6.1,6.1a1.57,1.57,0,0,0,0,2.2h0Z",
    fill: "#f79256"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3223",
    "data-name": "Path 3223",
    d: "M317.05,494.28a14.78,14.78,0,0,1-13.4-3.3,6.83,6.83,0,0,0-2,.3,4.72,4.72,0,0,0-1.9,1.1,6,6,0,0,0-5.2-3,6.2,6.2,0,0,0-3,.8V465a6.06,6.06,0,0,0-6-6.1h-.09a6.2,6.2,0,0,0-3,.8v-5.4a4.59,4.59,0,0,0-4.58-4.6H241.36a4.59,4.59,0,0,0-4.6,4.58v30.56h-1.5a7.6,7.6,0,0,0-7.6,7.6h0v6.2l3,31.9v9.1a1.54,1.54,0,0,0,1.5,1.5h33.5a1.55,1.55,0,0,0,1.5-1.5V531l5.7-8.1h3.29l1.7,4.8v11.9a1.55,1.55,0,0,0,1.5,1.5h30.5a1.54,1.54,0,0,0,1.5-1.5v-11.9l7-19.6a10.47,10.47,0,0,0,.6-3.6v-6a7,7,0,0,0-1.9-4.2Zm-53,43.9h-30.5v-6.1H264Zm.8-9.1h-31.3l-2.9-30.5v-6.1a4.59,4.59,0,0,1,4.58-4.6h10.72a4.55,4.55,0,0,1,.1,9.1h-7.7a1.54,1.54,0,0,0-1.5,1.5v19.8a4.58,4.58,0,0,0,4.58,4.6h27.82Zm-23.6-9.1a1.54,1.54,0,0,1-1.5-1.5v-4.6h27.4v-3h-27.4v-10.7h6.1a7.6,7.6,0,0,0,0-15.2h-6.1v-30.5a1.55,1.55,0,0,1,1.5-1.5H277.7a1.55,1.55,0,0,1,1.5,1.5v31.34a6.6,6.6,0,0,0-3.1-.9,6.06,6.06,0,0,0-6.09,6,.11.11,0,0,0,0,.08v13.7a11,11,0,0,0,.6,3.6L274.8,520Zm44.19,18.2h-4.6v-9.1h4.6Zm7.6,0h-4.6v-9.1H293Zm7.6,0H296v-9.1h4.6Zm7.6,0h-4.6v-9.1h4.6Zm7.6-33.5a11.36,11.36,0,0,1-.4,2.6l-6.7,18.8H280.4l-6.69-18.8a7.15,7.15,0,0,1-.4-2.6V491a3,3,0,1,1,6.09.1h0v12.2h3v-38.1a3,3,0,1,1,6,0h0v38.1h3v-7.6a3,3,0,1,1,6,0h0v7.6h3v-6.1a2.76,2.76,0,0,1,.9-2.1,2.48,2.48,0,0,1,1.2-.7,3.12,3.12,0,0,1,1-.2,3,3,0,0,1,3,3v7.64h3v-6.1a3,3,0,0,1,6,0h0Z",
    fill: "#f79256"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3224",
    "data-name": "Path 3224",
    d: "M259.46,456a15.2,15.2,0,1,0,15.2,15.2,15.2,15.2,0,0,0-15.2-15.2Zm0,27.4a12.2,12.2,0,1,1,12.2-12.2h0a12.18,12.18,0,0,1-12.16,12.2Z",
    fill: "#f79256"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3225",
    "data-name": "Path 3225",
    d: "M264,474.28a4.64,4.64,0,0,1-3,4.3v1.8h-3v-1.8a4.52,4.52,0,0,1-3-4.3h3a1.5,1.5,0,1,0,1.5-1.5h0a4.49,4.49,0,0,1-4.51-4.49.41.41,0,0,1,0-.11,4.63,4.63,0,0,1,3-4.3v-1.8h3v1.8a4.55,4.55,0,0,1,3,4.3h-3a1.5,1.5,0,1,0-1.5,1.5h0A4.59,4.59,0,0,1,264,474.28Z",
    fill: "#f79256"
  }))), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_388",
    "data-name": "Ellipse 388",
    cx: 255.92,
    cy: 512.37,
    r: 35,
    transform: "translate(-290.84 682.91) rotate(-80.78)",
    opacity: 0.3,
    fill: "url(#linear-gradient-3)",
    style: {
      isolation: "isolate"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "device_grp",
    "data-name": "device grp",
    className: "device"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_390",
    "data-name": "Ellipse 390",
    cx: 447.41,
    cy: 417.88,
    r: 28.5,
    opacity: 0.3,
    fill: "url(#linear-gradient-4)",
    style: {
      isolation: "isolate"
    }
  }), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Group_7245",
    "data-name": "Group 7245"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7244",
    "data-name": "Group 7244"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3226",
    "data-name": "Path 3226",
    d: "M475.81,389.08h-26.5a1.4,1.4,0,1,0-.2,2.8h26.7a1.38,1.38,0,0,0,1.31-1.44s0,0,0-.06A1.49,1.49,0,0,0,475.81,389.08Z",
    fill: "#24afa0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3227",
    "data-name": "Path 3227",
    d: "M475.81,397.68h-26.5a1.4,1.4,0,1,0-.2,2.8h26.7a1.38,1.38,0,0,0,1.31-1.44s0,0,0-.06A1.39,1.39,0,0,0,475.81,397.68Z",
    fill: "#24afa0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3228",
    "data-name": "Path 3228",
    d: "M451.81,452.17h-6.7a1.37,1.37,0,0,0-1.3,1.44v.06a1.32,1.32,0,0,0,1.3,1.3h6.7a1.37,1.37,0,0,0,1.31-1.43s0,0,0-.07A1.32,1.32,0,0,0,451.81,452.17Z",
    fill: "#24afa0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3229",
    "data-name": "Path 3229",
    d: "M465.91,452.17h-6.7a1.37,1.37,0,0,0-1.3,1.44v.06a1.32,1.32,0,0,0,1.3,1.3h6.7a1.37,1.37,0,0,0,1.31-1.43s0,0,0-.07A1.33,1.33,0,0,0,465.91,452.17Z",
    fill: "#24afa0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3230",
    "data-name": "Path 3230",
    d: "M480,452.17h-6.7a1.37,1.37,0,0,0-1.3,1.44v.06a1.32,1.32,0,0,0,1.3,1.3H480a1.37,1.37,0,0,0,1.31-1.43s0,0,0-.07A1.41,1.41,0,0,0,480,452.17Z",
    fill: "#24afa0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3231",
    "data-name": "Path 3231",
    d: "M451.81,458.47h-6.7a1.4,1.4,0,1,0-.2,2.8h6.9a1.4,1.4,0,0,0,.2-2.8Z",
    fill: "#24afa0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3232",
    "data-name": "Path 3232",
    d: "M465.91,458.47h-6.7a1.4,1.4,0,0,0-.2,2.8h6.9a1.4,1.4,0,1,0,.2-2.8Z",
    fill: "#24afa0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3233",
    "data-name": "Path 3233",
    d: "M480,458.47h-6.7a1.37,1.37,0,0,0-1.3,1.44V460a1.32,1.32,0,0,0,1.3,1.3H480a1.37,1.37,0,0,0,1.31-1.43s0,0,0-.07A1.41,1.41,0,0,0,480,458.47Z",
    fill: "#24afa0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3234",
    "data-name": "Path 3234",
    d: "M451.81,464.67h-6.7a1.37,1.37,0,0,0-1.3,1.44v.06a1.32,1.32,0,0,0,1.3,1.3h6.7a1.37,1.37,0,0,0,1.31-1.43s0,0,0-.07A1.41,1.41,0,0,0,451.81,464.67Z",
    fill: "#24afa0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3235",
    "data-name": "Path 3235",
    d: "M465.91,464.67h-6.7a1.4,1.4,0,1,0-.2,2.8h6.9a1.4,1.4,0,0,0,.2-2.8h-.2Z",
    fill: "#24afa0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3236",
    "data-name": "Path 3236",
    d: "M480,464.67h-6.7a1.37,1.37,0,0,0-1.3,1.44v.06a1.32,1.32,0,0,0,1.3,1.3H480a1.37,1.37,0,0,0,1.31-1.43s0,0,0-.07A1.5,1.5,0,0,0,480,464.67Z",
    fill: "#24afa0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3237",
    "data-name": "Path 3237",
    d: "M484.21,417.28a2.9,2.9,0,0,0-2.9-2.9h-37.5a2.9,2.9,0,0,0-2.9,2.9v4a1.4,1.4,0,0,0,2.8.2v-4.2a.1.1,0,0,1,.1-.1h37.5a.09.09,0,0,1,.1.1h0v14.6a.1.1,0,0,1-.1.1h-37.5a.11.11,0,0,1-.1-.1h0v-4a1.37,1.37,0,0,0-1.43-1.31h-.07a1.32,1.32,0,0,0-1.3,1.3v4a2.9,2.9,0,0,0,2.9,2.9h37.5a2.9,2.9,0,0,0,2.9-2.9Z",
    fill: "#24afa0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3238",
    "data-name": "Path 3238",
    d: "M453.81,441a2.8,2.8,0,0,0-2.8-2.8h-6.9a2.8,2.8,0,0,0-2.8,2.8,1.38,1.38,0,0,0,.1.6l.9,3.8a2.71,2.71,0,0,0,2.7,2.1h5.9a2.8,2.8,0,0,0,2.8-2.8Zm-8.7,3.8-.9-3.8H451v3.85Z",
    fill: "#24afa0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3239",
    "data-name": "Path 3239",
    d: "M468.91,444.83V441a2.8,2.8,0,0,0-2.8-2.8h-7.2a2.85,2.85,0,0,0-2.8,2.8v3.8a2.81,2.81,0,0,0,2.8,2.8h7.2A2.8,2.8,0,0,0,468.91,444.83Zm-10,0V441h7.2v3.8Z",
    fill: "#24afa0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3240",
    "data-name": "Path 3240",
    d: "M482.71,445.38l.9-3.8a2.83,2.83,0,0,0-2.1-3.4,1.12,1.12,0,0,0-.6-.1H474a2.8,2.8,0,0,0-2.8,2.8v3.8a2.85,2.85,0,0,0,2.8,2.79h5.9a2.62,2.62,0,0,0,2.8-2.09Zm-2.71-.55h-5.9V441h6.8Z",
    fill: "#24afa0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3241",
    "data-name": "Path 3241",
    d: "M503.61,393.88H496v-6.4h0a7,7,0,0,0-7.1-6.9h-41a7.49,7.49,0,0,0-7.5,7.48V400a8.47,8.47,0,0,0-7.1,8.3v18.6c0,10.5,1.8,13.3,1.8,23.49v18.45a7.13,7.13,0,0,0,7.1,7.1h40.6a7.12,7.12,0,0,0,7.1-7.1v-5.7a1.37,1.37,0,0,0-1.43-1.3h-.07a1.33,1.33,0,0,0-1.3,1.3v5.7a4.26,4.26,0,0,1-4.24,4.3H442.2a4.27,4.27,0,0,1-4.3-4.24V450.52c0-10.39-1.8-13.29-1.8-23.49v-18.7a5.48,5.48,0,0,1,4.3-5.4v3.6a3.6,3.6,0,0,0,3.58,3.6H480.9a3.59,3.59,0,0,0,3.6-3.58v-3.62a5.56,5.56,0,0,1,4.3,5.4v18.6c0,10.2-1.8,13.1-1.8,23.49v6a1.38,1.38,0,0,0,1.43,1.31h.07a1.32,1.32,0,0,0,1.3-1.3v-6c0-10.19,1.8-13.09,1.8-23.49v-12.6h8.7a7.13,7.13,0,0,0,7.1-7.1v-9.4a3.88,3.88,0,0,0-3.8-3.9Zm-21.8,12.5a.79.79,0,0,1-.78.8H444.11a.81.81,0,0,1-.8-.78V388.08a4.69,4.69,0,0,1,4.68-4.7h35.32a7.26,7.26,0,0,0-1.5,4.3Zm10,5.1v-3.2a8.38,8.38,0,0,0-7.1-8.3v-12.3a4.3,4.3,0,1,1,8.6-.2v19.7a6.69,6.69,0,0,0,1.5,4.3Zm12.8-4.3a4.3,4.3,0,0,1-8.6,0h0v-10.5h7.6a1,1,0,0,1,1,1Z",
    fill: "#24afa0"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "dollar_grp",
    "data-name": "dollar grp",
    className: "dollar"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_389",
    "data-name": "Ellipse 389",
    cx: 436.41,
    cy: 112.88,
    r: 28.5,
    opacity: 0.3,
    fill: "url(#linear-gradient-5)",
    style: {
      isolation: "isolate"
    }
  }), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Group_7246",
    "data-name": "Group 7246"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3242",
    "data-name": "Path 3242",
    d: "M448.83,76.88h-.6a3.93,3.93,0,0,1-3.5-4,1.8,1.8,0,0,0-3.6,0h0a7.62,7.62,0,0,0,5.5,7.3V82a1.8,1.8,0,0,0,3.6,0h0v-1.7a7.4,7.4,0,0,0,5.85-8.68c0-.07,0-.14-.05-.22a7.51,7.51,0,0,0-7.4-6,4,4,0,1,1,4-4,1.8,1.8,0,0,0,3.6,0,7.59,7.59,0,0,0-6-7.4v-1.6a1.8,1.8,0,0,0-3.6,0h0v1.7a7.47,7.47,0,0,0,2,14.7,4,4,0,0,1,4,4A4.06,4.06,0,0,1,448.83,76.88Z",
    fill: "#5d56c4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3243",
    "data-name": "Path 3243",
    d: "M423.13,67.28a25.5,25.5,0,1,0,25.6-25.6h0A25.66,25.66,0,0,0,423.13,67.28Zm25.6-22a22,22,0,1,1-22,22h0a21.87,21.87,0,0,1,21.74-22Z",
    fill: "#5d56c4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3244",
    "data-name": "Path 3244",
    d: "M482.93,97.08l-13.8,6.5a11.35,11.35,0,0,0-9.6-5.9l-12.7-.4A14.58,14.58,0,0,1,441,95.83l-1.3-.7a22.71,22.71,0,0,0-21.2,0l.1-2.8a1.71,1.71,0,0,0-1.62-1.8h-.08l-14-.4a1.7,1.7,0,0,0-1.79,1.62.22.22,0,0,0,0,.08h0l-.8,30.6a1.72,1.72,0,0,0,1.62,1.8H402l14,.4h.1a1.84,1.84,0,0,0,1.8-1.7v-1.5l3.6-1.9a6.14,6.14,0,0,1,4.6-.5l21.7,6.1h.1a25.81,25.81,0,0,0,4.8.5,23.65,23.65,0,0,0,9.8-2.1c.1,0,.1-.1.2-.1l31.4-20.3a1.75,1.75,0,0,0,.6-2.3,9,9,0,0,0-11.8-3.7Zm-79.1,23.75.8-27.1L415,94l-.7,27.1Zm57-.5a20.37,20.37,0,0,1-12.2,1.4l-21.6-6.1a9.82,9.82,0,0,0-7.3.8l-1.9,1,.5-18a19.34,19.34,0,0,1,19.7-1l1.3.7a17.06,17.06,0,0,0,7.3,1.9l12.8.3a7.57,7.57,0,0,1,7.3,6.2l-19-.5a1.75,1.75,0,1,0-.1,3.5h.1l20.9.5h0a1.84,1.84,0,0,0,1.8-1.7,8.92,8.92,0,0,0-.2-2.3l14.1-6.7h0a5.35,5.35,0,0,1,6.1.9Z",
    fill: "#5d56c4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3245",
    "data-name": "Path 3245",
    d: "M450.43,36.83V20.08a1.8,1.8,0,1,0-3.6,0V36.83a1.8,1.8,0,1,0,3.6,0Z",
    fill: "#5d56c4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3246",
    "data-name": "Path 3246",
    d: "M463.63,36.83v-7.9a1.8,1.8,0,0,0-3.6,0v7.9a1.8,1.8,0,0,0,3.6,0Z",
    fill: "#5d56c4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3247",
    "data-name": "Path 3247",
    d: "M437.23,36.83v-7.9a1.8,1.8,0,0,0-3.6,0v7.9a1.8,1.8,0,0,0,3.6,0Z",
    fill: "#5d56c4"
  })))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "paytack_logo",
    className: "paytack_logo"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1",
    "data-name": "Path 1",
    d: "M244.21,250.47V302c11.9-35.6,50.4-18.5,50.4-51.5a25.2,25.2,0,1,0-50.4,0Zm12.6,17.9v-17.9a12.6,12.6,0,0,1,25.2-.2v.2c0,13.2-15.4,12.5-25.2,17.9Z",
    transform: "translate(0.01 -0.17)",
    fill: "#2bc5b4",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_4",
    "data-name": "Group 4"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3",
    "data-name": "Group 3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2",
    "data-name": "Group 2"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1",
    "data-name": "Group 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_1",
    "data-name": "Rectangle 1",
    d: "M243.61,252.63h13.8v24.3h-13.8Z",
    transform: "translate(0.01 -0.17)",
    fill: "url(#Rectangle_1_1_)"
  })))))))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBenefitsUpdated);
export default __webpack_public_path__ + "static/media/benefits-updated.d85c7bc5.svg";
export { ForwardRef as ReactComponent };